/**
 * 
 * Routines utilitaires
 * 
 * 
 */


/**
 * Libère la cache PWA
 */
function clearPWACache() {

    caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => {
            caches.delete(cacheName);
        });
    });

}
window.clearPWACache = clearPWACache;

/**
 * Vide les stockage des collectes locaux
 * */
function clearCollecteCache() {
    if (typeof (Storage) !== "undefined") {

        sessionStorage.removeItem('collectesListSang');
        sessionStorage.removeItem('collectesListPlasma');
        sessionStorage.removeItem('collectesListPlaquettes');
    }

}
window.clearCollecteCache = clearCollecteCache;

/**
 * Créé un cookie
 * @param {any} key     Id du cookie
 * @param {any} value   Valeur à stocker
 * @param {any} days    Durée de validité en jours
 */
function setCookie(key, value, days) {

    var cryptedValue = CryptoJS.AES.encrypt(value, 'Z3D0nn3');

    var expires = new Date();
    if (days) {
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + cryptedValue + ';secure;samesite=strict;expires=' + expires.toUTCString();
    } else {
        document.cookie = key + '=' + cryptedValue + ';path=/';
    }
}
window.setCookie = setCookie;


/**
 * Lit un cookie
 * @param {any} key Id du cookie à lire
 */
function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    var cryptedValue = keyValue ? keyValue[2] : null;

    if (cryptedValue != null) {
        var bytes = CryptoJS.AES.decrypt(cryptedValue.toString(), 'Z3D0nn3');
        return bytes.toString(CryptoJS.enc.Utf8);

    } else {
        return null;
    }

}
window.getCookie = getCookie;

/**
 * Vérifie si la session est encore active
 * @param {any} callStatus  Code recu pour vérifier si la session est active
 */
function IsSessionExpired(callStatus) {

    if (callStatus != null) {
        //Si la session est expirée, on recois un code 203 et on redirige
        //a la page de reconnexion
        if (callStatus.status == 203) {
            window.location.href = '/user/mustbeloggedin';
            return true;
        }
    } else {
        window.location.href = '/statuscode/500';
        return true;
    }

    return false;

}
window.IsSessionExpired = IsSessionExpired;

/**
 * 
 * Fait une requête au serveur pour vérifier si on est online après l'utilisation de navigator.online
 * navigator.online n'est pas suffisant pour s'assurer que l'application est online, exemple, on as une connexion wi-fi mais pas authentifiée, donc pas d'Internet, mais une connexion est valide
 * */
function PingServer() {
    //Fonctionne mais pour une utilisation future
    ServerOnline(true);

}
window.PingServer = PingServer;


/**
 * Actions si l'application est online ou non
 * @param {any} status Statu du serveur
 */
function ServerOnline(status) {
    if (status) {
        ServerOK = true;
        console.log("online");

    } else {
        ServerOK = false;
        console.log("offline");
        //Redirige vers la page offline
        window.location.href = '/offline.html';
    }
}
window.ServerOnline = ServerOnline;

/**
 * Si le serveur revient en ligne on redirige
 */
function Reconnect() {
    if (ServerOK) {
        //Redirige sur la page d'accueil si serveur dispo
        // window.location.href = '/user/welcome';
    }
}
window.Reconnect = Reconnect;

/**
 * Affiche le loader pour un formulaire valide
 * @param {any} ctl Objet d'ou est appelé la fonction
 */
function ShowLoader(ctl) {

    window.clearTimeout(loaderTimeOut);

    if (ctl == undefined) {

        var screenW = $('.AppMainContainer').outerWidth();
        var leftLoader = Math.ceil(screenW / 2);
        $('#WaitModalManual').css('left', leftLoader + 'px');

        $('#ModalBack').show();
        $('#WaitModalManual').show();

        loaderTimeOut = window.setTimeout(CancelLoader, 45000);

    } else {
        //Avant de montrer le loader. il faut vérifié si cela viens d'une form et qu'elle est valide sinon
        //le loader apparait par dessus les messages d'erreurs, ne disparait pas et bloque la saisie
        if ($(ctl)[0].form != undefined) {

            if ($($(ctl)[0].form).valid()) {
                var screenW = $('.AppMainContainer').outerWidth();
                var leftLoader = Math.ceil(screenW / 2);
                $('#WaitModalManual').css('left', leftLoader + 'px');
                $('#ModalBack').show();
                $('#WaitModalManual').show();
                loaderTimeOut = window.setTimeout(CancelLoader, 45000);
            }

        } else {
            var screenW = $('.AppMainContainer').outerWidth();
            var leftLoader = Math.ceil(screenW / 2);
            $('#WaitModalManual').css('left', leftLoader + 'px');
            $('#ModalBack').show();
            $('#WaitModalManual').show();
            loaderTimeOut = window.setTimeout(CancelLoader, 45000);
        }
    }

}
window.ShowLoader = ShowLoader;

/** 
 *
 *Ferme le loader après un timeout pour éviter qu'il reste visible dans certains cas
 *Ex. En mode app sur Android, si on laisse l'app dormante, quand on reviens le loader est affiché et l'application est bloquée
 */
function CancelLoader() {
    window.clearTimeout(loaderTimeOut);

    $('#ModalBack').hide();
    $('#WaitModalManual').hide();
}
window.CancelLoader = CancelLoader;

/** 
 * Enregistre le consentement aux cookies
 */
(function () {

    $("#cookieConsent button[data-cookie-string]").click(function (el) {

        document.cookie = el.target.dataset.cookieString;
        $('#cookieConsent').hide();
        AjustAppPosCookieConsent();

    });

})();

/** 
 * Enregistre le consentement aux cookies
 * Utilisé aussi dans formatscreen.js
 */
function AjustAppPosCookieConsent() {

    if ($('#cookieConsent').css('display') == 'block') {
        $('.AppMainContainer').css('margin-top', '85px');
        $('.AppMainContainer').css('margin-top', '85px');
    } else {
        $('.AppMainContainer').css('margin-top', '0px');
    }

}
window.AjustAppPosCookieConsent = AjustAppPosCookieConsent;

/**
 * Vide une matrice
 * @param {any} arr Matrie à vider
 */
function clearArray(arr) {
    while (arr.length > 0) {
        arr.pop();
    }
};
window.clearArray = clearArray;

/**
 * Convertion d'une  chaine en majuscule
 * @param {any} str Chaine de caractère à convertir
 */
function sentenceCase(str) {
    return str.replace(/[a-z]/i, function (letter) {

        return letter.toUpperCase();

    }).trim();
}
window.sentenceCase = sentenceCase;


//Parse le URL pour obtenir les paramètres ex. $.urlParam('ville') retourne le montreal dans l'URL MyApp.com?ville=montreal
$.urlParam = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    }
    else {
        return results[1] || 0;
    }
}


/**
 * Pour enregistrer les événement Google analytics
 * @param {any} event           Événement déclenché
 * @param {any} eventCategory   Catégorie
 * @param {any} eventAction     Action à enregistrer
 * @param {any} eventLabel      Texte de l'action
 */
function Analytics(event, eventCategory, eventAction, eventLabel) {

    if (GAActive) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': event,
            'eventCategory': eventCategory,
            'eventAction': eventAction,
            'eventLabel': eventLabel
        });
    }

}
window.Analytics = Analytics;

/**
 * Pour enregistrer les événement Google analytics
 * @param {any} event   Événement déclenché
 * @param {any} url     URL de la page
 * @param {any} title   Titre
 */
function AnalyticsPageView(event, url, title) {

    if (GAActive) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': event,
            'virtualPageURL': url,
            'virtualPageTitle': title
        });
    }

}
window.AnalyticsPageView = AnalyticsPageView;

/**
 * Envoi d'un commentaire
 */
function GASendComment() {

    var r1 = $('#ComRadio-0').prop('checked');
    var r2 = $('#ComRadio-1').prop('checked');
    var r3 = $('#ComRadio-2').prop('checked');

    var commentType = '';

    if (r1) {
        commentType = 'Commentaire'
    }
    if (r2) {
        commentType = 'Question'
    }
    if (r3) {
        commentType = 'Soutien technique'
    }

    if (commentType != '' && $('#NousJoindreForm').valid()) {
        Analytics('gaEvent', 'nous joindre', 'formulaire de contact', 'formulaire envoyer | ' + commentType);
        ShowLoader();
    }

}
window.GASendComment = GASendComment;

/**
 * Fait la création d'un bouton d'installation pour PWa dans Android
 */
function AndroidPWABtnCreation() {

    const btnPWA = document.getElementById("btnPWA");

    btnPWA.explainer = $.parseHTML(TXTPWAExplainer)[0].textContent;
    btnPWA.featuresheader = $.parseHTML(LBLPWATitle)[0].textContent;;
    btnPWA.installbuttontext = $.parseHTML(LBLPWAInstall)[0].textContent;;

}
window.AndroidPWABtnCreation = AndroidPWABtnCreation;

/**
 * Ferme le panneau des RDV
 * @param {Event} ev Événement de l'objet
 */
function CloseRDV(ev) {

    //Si on as un événement, c'est du à un clic dans l'écran
    //si ca provient du panneau de droite on sort sinon on ferme le panneau
    if (ev != undefined) {

        if ($(ev.target).parents('.rightPanel').length) {
            return false;
        }

    }

    $("#logoutBack").css('display', 'none');
    $('.rdvPanel').velocity({
        translateX: '+100%'
    }, {
        complete: function (e) {

        }
    });

}
window.CloseRDV = CloseRDV;

/**
 * Empêche un double click
 */
function prevent_double_click() {
    clicked = true;
    setTimeout(function () {
        clicked = false;
    }, 1000);
}
window.prevent_double_click = prevent_double_click;

